import React, { useEffect, useRef } from 'react'; 
import MovieTimesPeriodeDaysItems from './MovieTimesPeriodeDaysItems';
import getPerformancesIntervall from '../functions/getPerformancesIntervall';
import Slider from 'react-slick';
import getDayKey from '../functions/getDayKey';
import getTranslationTime from '../functions/getTranslationTime';
import Translation from '../General/Translation';
import { SliderArrowNext, SliderArrowPrev } from '../SliderGeneral/SliderArrows';
import getMomentNow from '../functions/getMomentNow';
import getPerformancesIntervallByCinema from '../functions/getPerformanceIntervallByCinema';
import { compose } from 'redux';
import { connect } from 'react-redux';
import toJS from '../hoc/toJS';
import { FRONT, PROGRAM_CINEMAS, TRANSLATION } from '../constants/state';
import getData from '../functions/getData';

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT),
    translation: getData(state, TRANSLATION),
    cinemas: getData(state, PROGRAM_CINEMAS)
})


const getSortedCinemasObjects = (cinemaPk, cinemas) => {
    const sortedTheatres = cinemaPk.sort(function(a, b) {
        const cinemaA = cinemas[a]
        const cinemaB = cinemas[b]

        const aName = cinemaA.nameDisplay
        const bName = cinemaB.nameDisplay
        
        return bName > aName ? -1 : bName < aName ? 1 : 0
    })

    return sortedTheatres
}

const MovieTimesCinemaMobileContainer = ({
    movieId, 
    movieTitle,  
    translation, 
    cinemas, 
    performances, 
    onClick, 
    today, 
    currentDateActive, 
    activePerformance, 
    isMobile, 
    scrollToPosition, 
    onOpenIframe, 
    queryStringValues, 
    toggleShowtimes,
    cinemaDataFront,
    alternativeLinks
}) => {
    const sliderRef = useRef(null);
    const { timezone } = translation
    const {show_performancePrice} = cinemaDataFront
    const keyToday = getDayKey(today)
    const periodesDays = getPerformancesIntervall(performances, today, timezone)

    const firstPerformanceDateWithPerformances = _.findKey(periodesDays, (periodeDay) => {
        if(!periodeDay) {
            return
        }
        const hasPerformance = periodeDay.length > 0
        return hasPerformance
    })
    
    _.keys(periodesDays).map((pDayKey => {
        if (_.isEmpty(periodesDays[pDayKey])) {
            delete periodesDays[pDayKey];
        }
    }))
    
    const daySliderSettings = {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        focusOnSelect: true,
        swipeToSlide: true,
        beforeChange: (current, next) => {
            const currentSlideDate = _.keys(periodesDays)[next]
            if(currentSlideDate !== currentDateActive) {
                onClick(currentSlideDate)
            }
        },
        afterChange: current => {
            const currentSlideDate = _.keys(periodesDays)[current]
            if(currentSlideDate !== currentDateActive) {
                onClick(currentSlideDate)
            }
        },
        nextArrow: <SliderArrowNext />,
        prevArrow: <SliderArrowPrev />
    }

  
    
    useEffect(() => {  
        // if (sliderRef.current && sliderRef.current.slickGoTo && _.indexOf(_.keys(periodesDays), currentDateActive) !== -1) {
        //     sliderRef.current.slickGoTo(_.indexOf(_.keys(periodesDays), currentDateActive), true);
        // } else if (sliderRef.current?.slickGoTo) {
        //     sliderRef.current.slickGoTo(0, true);
        // }
        
        if( _.indexOf(_.keys(periodesDays), currentDateActive) === -1) {
            onClick(_.keys(periodesDays)[0])
        }
    }, []);
    
    const performancesContainer = _.keys(periodesDays).map((pDayKey, index) => {
        const periodeDay = periodesDays[pDayKey]
        if(!periodeDay) {
            return ''
        }

        let isActive = false
        const { timezone } = translation
        const dateNow = getMomentNow(timezone)
        const cinemasData = getPerformancesIntervallByCinema(periodeDay, today, dateNow, timezone, queryStringValues)
        
        if(!cinemasData) {
            return ''
        }

        const { dayIntervallKeys, cinemasObjects } = cinemasData
        const sortedObjectKeys = getSortedCinemasObjects(Object.keys(cinemasObjects), cinemas)

        const activePeriodeDayOnMobile = () => {
            if(isMobile) {
                if(currentDateActive === '' && firstPerformanceDateWithPerformances === pDayKey) {
                    return ' active'
                } else if(currentDateActive !== '' && currentDateActive === pDayKey) {
                    return ' active'
                } else {
                    return ' not-visible'
                }
            } else {
                return ''
            }
        }

        if(currentDateActive === '' && firstPerformanceDateWithPerformances === pDayKey) {
            isActive = true
        } else if(currentDateActive !== '' && currentDateActive === pDayKey) {
            isActive = true            
        }

        return (
            isActive ? (sortedObjectKeys.map((cinemaPk, index) => {
                const cinemaObjectData = cinemasObjects[cinemaPk]
                const { dayIntervall } = cinemaObjectData
                const cinema = cinemas[cinemaPk]
                const cinemaAlternativeLink = alternativeLinks && alternativeLinks[cinemaPk] ? alternativeLinks[cinemaPk] : null
                if(!cinema) {
                    return ''
                }

                const { nameDisplay } = cinema

                if(dayIntervall.length > 0) {
                    return ''
                }

                return (
                    <div key={index} className='sorted-showtimes-wrapper multicinema'>
                        <div className="theatre-and-attributes-wrapper">
                            <div className="title-xlarge-theatre theatre">{nameDisplay}</div>
                        </div>
                        <div className="movie-times-grid">
                            {dayIntervallKeys.map((dayKey, index) => {
                                const performances = dayIntervall[dayKey]

                                return (
                                    <div key={index} className={'showtime-container performances-wrapper'}>
                                        {performances && <MovieTimesPeriodeDaysItems 
                                            movieId={movieId}
                                            movieTitle={movieTitle}
                                            showPerformancePrice={show_performancePrice}
                                            toggleShowtimes={toggleShowtimes}
                                            performances={performances} 
                                            activePerformance={activePerformance}
                                            alternativeLink={cinemaAlternativeLink}
                                            additionalClass={activePeriodeDayOnMobile()}
                                            translation={translation}
                                            isMobile={isMobile}
                                            scrollToPosition={scrollToPosition}
                                            onOpenIframe={onOpenIframe}
                                        />}
                                    </div>  
                                )

                            })}
                        </div>
                    </div>
                )
            })):('')
        )
    })

    return (
        <div className='mobile-slider-movietimes'>
            {_.keys(periodesDays).length < 4 ? (
                <div className='date-slider-day-container'>
                    {_.keys(periodesDays).map((dayPk, index) => {
                        const isToday = keyToday === dayPk
                        const isActiveClass = dayPk === currentDateActive ? ' active-day' : ''
                        const performancesLength = periodesDays[dayPk].length
                        const dayFormarted = isToday ? <Translation id="today" trans={translation}>Heute</Translation> : getTranslationTime('performanceDates', translation, dayPk)

                        return performancesLength > 0 && <div className={'date-slider-day-wrapper' + isActiveClass} key={index} onClick={() => {onClick(dayPk)}}>
                            <p className='date-slider-day'>{dayFormarted}</p>
                        </div>
                    })}
            </div>
            ) : ( 
                <Slider ref={sliderRef} className='date-slider' {...daySliderSettings}>
                    {_.keys(periodesDays).map((dayPk, index) => {
                        const isToday = keyToday === dayPk
                        const performancesLength = periodesDays[dayPk].length
                        const dayFormarted = isToday ? <Translation id="today" trans={translation}>Heute</Translation> : getTranslationTime('performanceDates', translation, dayPk)

                        return performancesLength > 0 && <div className='date-slider-day-wrapper' key={index}>
                            <p className='date-slider-day'>{dayFormarted}</p>
                        </div>
                    })}
                </Slider>
            )}
            {performancesContainer}
        </div>
    )
}


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(MovieTimesCinemaMobileContainer)